// extracted by mini-css-extract-plugin
module.exports = {"DarkBtn":"Theme-module--DarkBtn--tXE1T","LightBtn":"Theme-module--LightBtn--3DRtm"};